/**
 * Constants for switchboard canvas custom handles
 */

export const CUSTOM_HANDLE_PREFIXES = [
  'on',
  'option-',
  'when',
  'holiday',
] as const

export const AUTO_GENERATED_EDGE_PREFIX = 'xy-edge__'

// Type definitions for handle types
export type CustomHandleType = 'onInvalid' | 'onTimeout'
export type ScheduleHandleType = 'whenOpen' | 'whenClosed' | 'holiday'
export type DayNightHandleType = 'whenOpen' | 'whenClosed'
export type QueueHandleType = 'onTimeout' | 'onEscape'
export type TransferAndRolloverHandleType = 'noAnswer' | 'busy'

// Arrays for backward compatibility (used in some places)
export const CUSTOM_HANDLE_TYPES = ['onInvalid', 'onTimeout'] as const
export const SCHEDULE_HANDLE_TYPES = [
  'whenOpen',
  'whenClosed',
  'holiday',
] as const
export const DAY_NIGHT_HANDLE_TYPES = ['whenOpen', 'whenClosed'] as const
export const QUEUE_HANDLE_TYPES = ['onTimeout', 'onEscape'] as const
export const TRANSFER_AND_ROLLOVER_HANDLE_TYPES = ['noAnswer', 'busy'] as const

// Typed Sets for efficient lookups and type safety
export const CUSTOM_HANDLE_TYPES_SET = new Set<CustomHandleType>(
  CUSTOM_HANDLE_TYPES,
)
export const SCHEDULE_HANDLE_TYPES_SET = new Set<ScheduleHandleType>(
  SCHEDULE_HANDLE_TYPES,
)
export const DAY_NIGHT_HANDLE_TYPES_SET = new Set<DayNightHandleType>(
  DAY_NIGHT_HANDLE_TYPES,
)
export const QUEUE_HANDLE_TYPES_SET = new Set<QueueHandleType>(
  QUEUE_HANDLE_TYPES,
)
export const TRANSFER_AND_ROLLOVER_HANDLE_TYPES_SET =
  new Set<TransferAndRolloverHandleType>(TRANSFER_AND_ROLLOVER_HANDLE_TYPES)
